import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { api, apiError } from "@/lib/api";

const when = (iso) => new Date(iso).toLocaleString("en-GB", { dateStyle: "long", timeStyle: "short" });
const MSG = {
  cancelled: "This reset request has been cancelled. Two-step verification stays on.",
  completed: "Two-step verification has been reset. You'll set it up again the next time you log in.",
};

export default function MfaRecovery() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const load = () => api.get("/auth/mfa/recovery/status", { params: { token } }).then((r) => setInfo(r.data)).catch((e) => setError(apiError(e)));
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const act = async (what) => {
    if (what === "complete" && !window.confirm("Reset two-step verification now? You'll be signed out everywhere.")) return;
    try { await api.post(`/auth/mfa/recovery/${what}`, { token }); load(); } catch (e) { setError(apiError(e)); }
  };
  return (
    <div className="min-h-screen legacy-bg">
      <Navbar />
      <main className="max-w-lg mx-auto px-4 py-10">
        <div className="glass-card p-7 sm:p-9 space-y-5" data-testid="mfa-recovery-page">
          <h1 className="font-serif text-3xl text-[#EDE6F7]">Reset two-step verification</h1>
          {error && <p role="alert" className="text-[#E6CCF2]" data-testid="mfa-recovery-error">{error}</p>}
          {info && MSG[info.status] && <p className="text-[#C9B6FF]" data-testid="mfa-recovery-status">{MSG[info.status]}</p>}
          {info?.status === "pending" && (
            <>
              <p className="text-[#B9B3C8]" data-testid="mfa-recovery-status">{info.ready ? "The 24-hour safety wait is over. You can now reset two-step verification." : `For your security, this can be completed after ${when(info.eligible_at)}.`}</p>
              {info.ready && <button type="button" onClick={() => act("complete")} className="gold-btn w-full h-14 rounded-full text-lg" data-testid="mfa-recovery-complete">Reset two-step verification</button>}
              <button type="button" onClick={() => act("cancel")} className="w-full h-12 rounded-full border border-[#8B2CFF] text-[#EDE6F7] hover:bg-[#241634]" data-testid="mfa-recovery-cancel">This wasn't me — cancel the request</button>
            </>
          )}
          <Link to="/signin?mode=login" className="block text-center text-[#C9B6FF] underline underline-offset-4" data-testid="mfa-recovery-signin">Go to log in</Link>
        </div>
      </main>
    </div>
  );
}
